export default __webpack_public_path__ + "static/WojciechKalinowski-19cfa0f77fa28a0b66a92ca05343eca6.png";